import type { BragBarV2Props as Props } from './types';
import { cls } from '@/utils/cls';
import Image from 'next/image';
import style from './BragBarV2.module.scss';
import { isBuilderPreview } from '@/utils/isBuilderPreview';
import { useEffect, useState } from 'react';
export default function BragBarV2({
  items = [],
  backgroundColor,
  borderColor,
  textColor,
  textSizeMobile,
  textSizeDesktop
}: Props) {
  const [inBuilderPreview, setInBuilderPreview] = useState(false);
  useEffect(() => {
    setInBuilderPreview(isBuilderPreview());
  }, []);

  // Filter items that have at least an icon or text
  const validItems = items.filter(item => item.icon || item.text);
  if (validItems.length === 0) {
    if (inBuilderPreview) {
      return <div className={style.previewBanner}>📌 BragBarV2 Preview - Remember to add items</div>;
    }
    return null;
  }
  return <section aria-label="Trust indicators" className={style.root} style={{
    backgroundColor: backgroundColor
  }} data-sentry-component="BragBarV2" data-sentry-source-file="BragBarV2.tsx">
			<div className={style.bragBarWrapper} style={{
      borderColor: borderColor
    }}>
				<ul className={cls(style.itemWrapper, style.divideX)} style={{
        '--grid-columns': validItems.length
      } as React.CSSProperties}>
					{validItems.map((item, index) => <li key={`brag-v2-item-${index}`} className={style.item} style={{
          borderColor: borderColor
        }}>
							{item.icon && <div className={style.imageWrapper}>
									<Image src={item.icon} width={25} height={25} alt="" role="presentation" className={style.image} unoptimized />
								</div>}

							{item.text && <p className={style.text} style={{
            color: textColor,
            '--text-size-mobile': `${textSizeMobile ?? 0.625}rem`,
            '--text-size-desktop': `${textSizeDesktop ?? 0.75}rem`
          } as React.CSSProperties}>
									{item.text}
								</p>}
						</li>)}
				</ul>
			</div>
		</section>;
}